import React, { Component } from 'react';
import ClassNames from 'classnames';

class Paging extends Component {
  constructor(props) {
    super(props);
    let { start = 1, step = 1, selected = 1, type = 'step' } = this.props;

    this.state = {
      selected: selected,
      start: start,
      step: step,
      type: type,
    };
  }

  parentComponentSendNo = (no) => {
    if (this.props.onClick) {
      this.props.onClick(no);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    let { step } = this.state;
    let isModify = {
      step: false,
    };
    if (step !== nextProps.step) {
      isModify.step = true;
    }

    if (isModify.step) {
      this.setState({
        step: isModify.step ? nextProps.step : step,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selected !== prevProps.selected) {
      this.setState({
        selected: this.props.selected,
      });
    }
  }

  prevNext(e, command, max) {
    e.preventDefault();
    let { start, step, type, selected } = this.state;
    let startResult = start;
    let selectedResult = selected;
    switch (command) {
      case 'prev':
        if ('jump' === type) {
          startResult = start - step > 0 ? start - step : 1;
          selectedResult = start - step > 0 ? startResult + step - 1 : 1;
        } else if ('step' === type) {
          selectedResult = selected - 1 > 0 ? selected - 1 : 1;
          if (start > selectedResult) {
            startResult = start - step;
          }
        }
        break;
      case 'next':
        if ('jump' === type) {
          startResult = start + step <= max ? start + step : start;
          selectedResult = start + step <= max ? start + step : max;
        } else if ('step' === type) {
          selectedResult = selected + 1 <= max ? selected + 1 : max;
          if (start + step <= selectedResult) {
            startResult = start + step;
          }
        }
        break;
      default:
        break;
    }
    this.changeStater({ start: startResult, step, selected: selectedResult });
  }

  noClick(e, no) {
    e.preventDefault();
    let { start, step } = this.state;
    this.changeStater({ start, step, selected: no });
  }

  makeArr(start, step, max) {
    let arr = [];
    for (let i = start; i < start + step; i++) {
      if (i <= max) {
        arr.push(i);
      }
    }
    return arr;
  }

  changeStater = ({ start, step, selected }) => {
    this.parentComponentSendNo(selected);
    this.setState({
      start,
      step,
      selected,
    });
  };

  render() {
    let { start, step, selected } = this.state;
    let { count = 1, pageSize = 1 } = this.props;
    if (count < 1 || pageSize < 1) {
      return null;
    }
    let max = count / pageSize;
    max = Math.ceil(max);
    //스텝이 맥스보다 크면 맥스를 선택 아니면 스텝 선택
    let decideStep = max < step ? max : step;
    let buttonArr = this.makeArr(start, decideStep, max);
    return (
      <div className="paging-navigation">
        <a
          href="#"
          className="prev"
          onClick={(e) => {
            this.prevNext(e, 'prev', max);
          }}
        >
          이전 목록
        </a>
        <ul>
          {buttonArr.map((item, index) => {
            return (
              <li key={index} className={ClassNames({ on: item === selected })}>
                <a
                  href="#"
                  onClick={(e, no) => {
                    this.noClick(e, item);
                  }}
                >
                  {item}
                </a>
              </li>
            );
          })}
        </ul>
        <a
          href="#"
          className="next"
          onClick={(e) => {
            this.prevNext(e, 'next', max);
          }}
        >
          다음 목록
        </a>
      </div>
    );
  }
}

export default Paging;
